import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// ****** Services ****** //
import AuthRequest from '../../../services/AuthRequest/AuthRequest';
// ****** Tools ****** //
import axios from 'axios';
import Cookies from 'js-cookie';
import { setAuthToken, safeRedirect } from '../../../services/session';
import { toast } from 'react-hot-toast';
import { config } from '../../../config/config';
// ****** Sweetalert2 ****** //
import Alert from '../../../utils/lazyAlert';
import logo from '../../../assets/images/comment.png';
import exit from '../../../assets/images/exit-alert.png';
const initialState = {
  loading: false,
  user_checking_loading: false,
  is_user_exist: 'idle',
};


export const checkUserExistence = createAsyncThunk(
  'auth/checkUserExistence',
  async ({ key, value }) => {
    try {
      if (key && value) {
        let data = new FormData();
        data.append(key, value);
        await axios.post(`${config.BASE_URL}/api/v1/user/checkUser`, data);
        return 'success';
      }
    } catch (ex) {
      return 'error';
    }
  },
);

export const loginUser = createAsyncThunk('auth/loginUser', async (initialData) => {
  try {
    const { status, data } = await AuthRequest.Login(initialData);
    if (status >= 200) {
      setAuthToken(data.access_token, 30);
      const redirectUrl = localStorage.getItem('redirectUrl');
      toast.success('ورود به با موفقیت انجام شد');
      if (redirectUrl) {
        localStorage.removeItem('redirectUrl');
        window.location.replace(safeRedirect(redirectUrl));
      } else {
        window.location.replace('/');
      }
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const loginWithGoogle = createAsyncThunk('auth/loginWithGoogle', async (credential) => {
  try {
    const { status, data } = await AuthRequest.LoginWithGoogle(credential);
    if (status >= 200) {
      setAuthToken(data.access_token, 30);
      const redirectUrl = localStorage.getItem('redirectUrl');
      toast.success('ورود با موفقیت انجام شد');
      if (redirectUrl) {
        localStorage.removeItem('redirectUrl');
        window.location.replace(safeRedirect(redirectUrl));
      } else {
        window.location.replace('/');
      }
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const loginWithApple = createAsyncThunk('auth/loginWithApple', async (payload) => {
  try {
    const { status, data } = await AuthRequest.LoginWithApple(payload);
    if (status >= 200) {
      setAuthToken(data.access_token, 30);
      const redirectUrl = localStorage.getItem('redirectUrl');
      toast.success('ورود با موفقیت انجام شد');
      if (redirectUrl) {
        localStorage.removeItem('redirectUrl');
        window.location.replace(safeRedirect(redirectUrl));
      } else {
        window.location.replace('/');
      }
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const logoutUser = createAsyncThunk('auth/logoutUser', async () => {
  const { sweet_alert_basic } = config;

  try {
    const { isConfirmed } = await Alert.fire({
      ...sweet_alert_basic,

      title: "برای خروج از حساب کاربری مطمئن هستید؟",
      html: ` 
      <div class="d-flex justify-content-center m-0 p-0">
       <ul class="my-0 py-0" >
            <li  class="modal-text-wrap">نشانه‌ها و لیست هایی که ذخیره کردید باقی می‌مانند.</li>
            <li class="modal-text-wrap">برای دسترسی به امکانات، دوباره باید وارد حساب کاربری شوید.</li>
          </ul>
          </div>
         `,
      imageUrl: logo,
      imageWidth: 80,
      showCancelButton: true,
      confirmButtonText: ` <img src="${exit}" class="img-exit-modal" />بله `,
      cancelButtonText: 'انصراف',
      reverseButtons: false,
      buttonsStyling: false,
      customClass: {
        popup: 'rounded-4 shadow-lg my-swal-popup',
        icon: 'border-0',
        confirmButton: 'btnModal mx-2',
        cancelButton: 'btnModalCancel mx-2',
        title:'modal-title-wrap mt-2',
        image:'mb-0 py-0',
        html:'m-0 p-0'
      },
      backdrop: true,
      width: '34rem',
      
    });

    if (isConfirmed) {
      Cookies.remove('iran_token');
      try {
        await AuthRequest.Logout();
      } catch {}
      window.location.replace('/');
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const registerOTP = createAsyncThunk('auth/registerOTP', async (initialData) => {
  try {
    const { status } = await AuthRequest.Regsiter(initialData);
    if (status >= 200) {
      setTimeout(() => {
        window.location.replace('/active-user');
      }, 1500);
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const registerInfo = createAsyncThunk('auth/registerInfo', async (initialData) => {
  try {
    const { status, data } = await AuthRequest.RegsiterInfo(initialData);
    if (status >= 200) {
      setAuthToken(data['0']['original']);
      window.location.replace('/register-activites');
      localStorage.removeItem('mobile');
      localStorage.removeItem('email');
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const activeUserBySms = createAsyncThunk(
  'auth/activeUser',
  async ({ initialData, is_forget_password }) => {
    try {
      const { status } = await AuthRequest.Activation(initialData);
      if (status >= 200) {
        toast.success('موفقیت آمیز بود');
        if (!is_forget_password) {
          window.location.replace('/register-info');
        } else {
          window.location.replace('/change-password');
        }
      }
    } catch (ex) {
      console.log(ex);
    }
  },
);

export const forgetPassword = createAsyncThunk('auth/forgetPassword', async (initialData) => {
  try {
    const { status } = await AuthRequest.ForgetPassword(initialData);
    if (status >= 200) {
      window.location.replace('/reset-password');
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const changePassword = createAsyncThunk('auth/changePassword', async (initialData) => {
  const mobile = localStorage.getItem('mobile');
  const otp_code = localStorage.getItem('otp_code');
  const email = localStorage.getItem('email');
  console.log(initialData);
  const payload = {
    password: initialData.password,
    c_password: initialData.c_password,
    otp_code,
  };

  if (mobile) {
    payload.mobile = mobile;
    payload.type = mobile;
  }

  if (email) {
    payload.email = email;
    payload.type = email;
  }

  try {
    const { status } = await AuthRequest.ChangePassword(payload);
    if (status >= 200) {
      window.location.replace('/login');
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginUser.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(registerOTP.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerOTP.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(activeUserBySms.pending, (state) => {
        state.loading = true;
      })
      .addCase(activeUserBySms.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(registerInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerInfo.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(checkUserExistence.pending, (state) => {
        state.user_checking_loading = true;
        state.is_user_exist = 'idle';
      })
      .addCase(checkUserExistence.fulfilled, (state, { payload }) => {
        state.is_user_exist = payload;

        state.user_checking_loading = false;
      });
  },
});

export default authSlice.reducer;
